import { BKJButton, Flex } from '@bookjane2/bookjane-design-library';
import styled from 'styled-components';

export const CustomerSettingsPageTitle = styled.h3`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
`;

export const CustomerSettingsTableRow = styled(Flex)<{ $isGrey: boolean }>`
  background-color: ${({ $isGrey = false, theme }) => $isGrey && theme.colors.Grey1};
  height: 72px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey5};
`;

export const CustomerSettingsPageSubtitle = styled.h4`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 20px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0;
`;

export const CustomerSettingsHeaderCellLayout = styled(Flex)`
  padding: 24px 16px 24px 16px;
`;

export const CustomerSettingsBodyCellLayout = styled(Flex)`
  padding: 12px 16px 12px 16px;
`;

export const CustomerSettingsHeaderRow = styled(Flex)`
  border-bottom: 4px solid ${({ theme }) => theme.colors.Grey4};
`;

export const CustomerSettingsHeaderCell = styled.h4`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 20px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0;
`;
export const CustomerSettingsBodyCell = styled.div`
  ${({ theme }) => theme.fonts.Poppins};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
`;

export const LocationsCount = styled.span`
  color: ${({ theme }) => theme.colors.AccentPurple};
  text-decoration: underline;
  cursor: pointer;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;

  &:hover {
    opacity: 0.8;
  }
`;

export const AddNewCustomerButton = styled(BKJButton)`
  width: fit-content;
  padding: 44px 16px;
  font-size: 16px;
  ${({ theme }) => theme.fonts.PoppinsBold};
`;

export const EditCustomerLink = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.AccentPurple};
  font-size: 16px;
  line-height: 22px;
  ${({ theme }) => theme.fonts.PoppinsText};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;

export const AddNewCustomerFormWrapper = styled.form`
  gap: 40px;
  flex-direction: column;
  width: 100%;
  display: flex;
`;

export const SectionTitle = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  font-size: 20px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
`;

export const LocationSection = styled(Flex)<{ isAlternate?: boolean }>`
  flex-direction: column;
  background-color: 'transparent';
  border-radius: ${({ isAlternate }) => (isAlternate ? '8px' : '0')};
  margin: ${({ isAlternate }) => (isAlternate ? '16px 0' : '0')};
`;

export const LocationHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

export const LocationTitle = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  font-size: 20px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
`;

export const RemoveLocationButton = styled(BKJButton)`
  font-size: 14px;
  ${({ theme }) => theme.fonts.PoppinsText};
`;

export const LocationFieldsWrapper = styled(Flex)`
  gap: 16px;
  flex-direction: column;
`;

export const FieldRow = styled(Flex)`
  gap: 16px;
  flex-direction: row;
  align-items: flex-start;
`;

export const FieldColumn = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
`;

export const ContactInformationTitle = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  font-size: 18px;
  margin: 16px 0 8px 0;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
`;

export const AddLocationButton = styled(BKJButton)`
  margin-top: 16px;
  align-self: flex-start;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;
  display: flex;
  gap: 10px;
`;

export const ActionButtonsWrapper = styled(Flex)`
  gap: 40px;
  padding: 40px 0 0 0;
  margin-top: 32px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
  flex-direction: column;
`;

export const ActionButton = styled(BKJButton)`
  min-width: 120px;
  max-width: 192px;
  ${({ theme }) => theme.fonts.PoppinsText};
`;

export const ErrorMessage = styled(Flex)`
  color: ${({ theme }) => theme.colors.ErrorDefault};
  font-size: 14px;
  margin-bottom: 16px;
  ${({ theme }) => theme.fonts.PoppinsText};
`;

export const EditViewWrapper = styled(Flex)`
  gap: 40px;
  flex-direction: column;
  width: 100%;
  max-height: 600px;
`;

export const SaveButton = styled(BKJButton)`
  font-size: 16px;
  min-height: 44px;
  ${({ theme }) => theme.fonts.PoppinsText};
`;

export const AddCustomerButton = styled(BKJButton)`
  margin-top: 40px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;
  gap: 10px;
  display: flex;
`;
